export default {
  marketManOrders: [],
  marketManOrder: undefined,
};
